import { render, staticRenderFns } from "./ManagerCompaniesView.vue?vue&type=template&id=6b7f5744&scoped=true"
import script from "./ManagerCompaniesView.vue?vue&type=script&lang=js"
export * from "./ManagerCompaniesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f5744",
  null
  
)

export default component.exports